/* eslint-disable no-alert */
import Vue from 'vue';
import FormDataService from 'services/form-data.service';
import AddEditMixin from '../shared/AddEditMixin';
import AddEditForm from '../shared/AddEditForm';
import AutoComplete from '../shared/AutoComplete.vue';
import Mappings from '../oil-sample/SampleDetail/OilSampleAutoCompleteMaps';
import FluidBrandConstants from '../../constants/column-name/fluid-brand.column-name.constants';
import FluidTypeConstants from '../../constants/fluid-types.constants';

export default Vue.extend({
  name: 'FluidBrandAddEditForm',
  props: {
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {},
      mappings: Mappings
    };
  },
  computed: {
    formTitle() {
      return this.isEditMode ? 'Edit Fluid Brand' : 'Add Fluid Brand';
    }
  },
  mixins: [AddEditMixin],
  methods: {
    checkForm() {
      return this.checkFormSubmission({ FluidBrandConstants });
    },
    openDialog(data) {
      this.formData = {
        fluidBrandName: data?.fluidBrandName,
        fluidBrandID: data?.fluidBrandID,
        isActive: data?.isActive,
        isDeleted: data?.isDeleted,
        fluidTypeID: data?.fluidTypeID,
        fluidTypeCode:
          data?.fluidTypeID === FluidTypeConstants.CoolantId ? FluidTypeConstants.Coolant : FluidTypeConstants.Oil
      };
      this.$nextTick(() => {
        this.$refs.addEditForm.openDialog(this.formData);
      });
    },
    typeChange() {
      this.formData = {
        ...this.formData,
        fluidTypeID:
          this.formData.fluidTypeCode === FluidTypeConstants.Coolant
            ? FluidTypeConstants.CoolantId
            : FluidTypeConstants.OilId
      };
    }
  },
  components: {
    AddEditForm,
    AutoComplete
  },
  beforeCreate() {
    // eslint-disable-next-line global-require
    this.$options.components.AutoComplete = require('../shared/AutoComplete.vue').default;
  },
  template: `
    <AddEditForm :title="formTitle" ref="addEditForm" @submit-button-clicked="onFormSubmit">
    ${FormDataService.textInput(FluidBrandConstants.fluidBrandName)}
    <div>Fluid Type</div>
       <span class="radio-margin-right">${FormDataService.radioInput(
         FluidTypeConstants.Oil,
         FluidBrandConstants.fluidTypeCode.field,
         'typeChange'
       )}</span>
      ${FormDataService.radioInput(FluidTypeConstants.Coolant, FluidBrandConstants.fluidTypeCode.field, 'typeChange')}
    </AddEditForm>
  `
});
